import React from 'react'

const Health = () => {
  return (
    <div>Health</div>
  )
}

export default Health